// Page heading (other Business UI handoff): eyebrow (section / page), a
// 32px title, one line of intro, and the screen's ONE primary action on the
// right. Every screen answers: what is happening, what needs attention, what
// happens next.
import type { ReactNode } from "react";

interface PageHeaderProps {
  /** "Sales / Overview" — the breadcrumb-style location. */
  eyebrow?: ReactNode;
  title: ReactNode;
  intro?: ReactNode;
  /** The dominant action (usually one primary Button). */
  action?: ReactNode;
}

export function PageHeader({ eyebrow, title, intro, action }: PageHeaderProps) {
  return (
    <header className="mb-7 mt-2 flex flex-wrap items-center justify-between gap-6">
      <div className="min-w-0">
        {eyebrow ? (
          <p className="text-[11px] font-medium uppercase tracking-[0.12em] text-muted">{eyebrow}</p>
        ) : null}
        <h1 className="mb-2.5 mt-2 text-[32px] font-semibold leading-[1.15] tracking-[-1px] text-ink">{title}</h1>
        {intro ? <p className="max-w-2xl text-sm text-muted">{intro}</p> : null}
      </div>
      {action ? <div className="flex shrink-0 items-center gap-3">{action}</div> : null}
    </header>
  );
}
